module.exports = __webpack_public_path__ + "static/media/HB_logo.6314a7a2.png";